import script from "./MGButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./MGButton.vue?vue&type=script&setup=true&lang=ts"

import "./MGButton.vue?vue&type=style&index=0&id=1d2b4c0f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d2b4c0f"]])

export default __exports__